const translations = {
  fr: {
    translation: {
      'app.title': 'HinaPulse',
      'app.subtitle': 'Plateforme de Gouvernance IA',
      'menu.home': 'Accueil',
      'menu.users': 'Utilisateurs',
      'menu.trust_passport': 'Passeport de Confiance',
      'menu.activities': 'Historique Activités',
      'menu.settings': 'Configuration et Pilotage',
      'menu.admin': 'Panneau Admin',
      'menu.logout': 'Déconnexion',
      'breadcrumb.home': 'Accueil',
      'breadcrumb.users': 'Utilisateurs',
      'breadcrumb.passport': 'Passeport de Confiance',
      'breadcrumb.settings': 'Paramètres',
      'common.search': 'Rechercher...',
      'common.overview': 'Aperçu',
      'common.edit': 'Modifier',
      'common.delete': 'Supprimer',
      'common.save': 'Enregistrer',
      'common.cancel': 'Annuler',
      'common.add': 'Ajouter',
      'common.back': 'Retour',
      'common.loading': 'Chargement...',
      'common.error': 'Erreur',
      'common.success': 'Succès',
      'common.name': 'Nom',
      'common.title': 'Titre',
      'common.description': 'Description',
      'common.status': 'État',
      'common.date': 'Date',
      'common.not_found': 'Aucun élément trouvé',
      'common.reset': 'Réinitialiser',
      'common.all': 'Tous',
      'common.owner': 'Propriétaire',
      'common.members': 'Membres',
      'breadcrumb.activities': 'Historique des Activités',
      'activity.title': 'Historique des Activités',
      'activity.subtitle': 'Suivi de toutes les actions effectuées sur les projets IA',
      'activity.filter_type': 'Type d\'action',
      'activity.filter_status': 'Statut',
      'activity.filter_days': 'Jours écoulés',
      'activity.created_project': 'Projet créé',
      'activity.created_passport': 'Passeport créé',
      'activity.updated_passport': 'Passeport mis à jour',
      'activity.signed_passport': 'Passeport signé',
      'activity.created_alert': 'Alerte créée',
      'activity.added_data_source': 'Source de données ajoutée',
      'activity.success': 'Succès',
      'activity.warning': 'Avertissement',
      'activity.no_activities': 'Aucune activité trouvée',
      'activity.total_activities': 'Activités Totales',
      'activity.projects_created': 'Projets Créés',
      'activity.passports_created': 'Passeports Créés',
      'activity.alerts_created': 'Alertes Créées',
      'auth.profile': 'Mon Profil',
      'auth.settings': 'Paramètres',
      'auth.language': 'Langue',
      'auth.french': 'Français',
      'auth.english': 'Anglais',
      'dashboard.title': 'Tableau de Bord',
      'dashboard.projects': 'Projets IA',
      'dashboard.active_projects': 'Projets Actifs',
      'dashboard.alerts': 'Alertes',
      'dashboard.recent_activity': 'Activité Récente',
      'dashboard.pipeline_progress': 'Progression du Pipeline',
      'dashboard.global_progress': 'Progression Globale des Projets',
      'dashboard.total_projects': 'Total Projets',
      'dashboard.avg_progress': 'Progression Moyenne',
      'dashboard.avg_trust_score': 'Score Moyen',
      'dashboard.progress': 'Progression',
      'dashboard.statistics': 'Statistiques',
      'dashboard.current_phase': 'Phase Actuelle',
      'dashboard.checkpoints': 'Points de Contrôle',
      'dashboard.phases_completed': 'Phases Complétées',
      'projects.team_size': 'Taille Équipe',
      'projects.budget': 'Budget',
      'projects.risk_level': 'Niveau de Risque',
      'projects.compliance': 'Conformité',
      'projects.data_sources': 'Sources de Données',
      'projects.stakeholders': 'Parties Prenantes',
      'projects.checkpoints': 'Points de Contrôle',
      'pipeline.ideation': 'Idéation',
      'pipeline.data_collection': 'Collecte Data',
      'pipeline.training': 'Entraînement',
      'pipeline.deployment': 'Déploiement',
      'phase.status_pending': 'En attente',
      'phase.status_in_progress': 'En cours',
      'phase.status_blocked': 'Bloqué',
      'phase.status_completed': 'Complété',
      'checkpoint.validation': 'Validation des Points de Contrôle',
      'checkpoint.verified': 'Vérifié',
      'checkpoint.pending': 'En attente',
      'alert.level_red': 'Critique',
      'alert.level_yellow': 'Attention',
      'alert.level_green': 'Conforme',
      'alert.priority': 'Priorité',
      'alert.priority_critical': 'Critique',
      'alert.priority_high': 'Haute',
      'alert.priority_medium': 'Moyenne',
      'alert.priority_low': 'Basse',
      'remediation.proposed': 'Proposé',
      'remediation.in_progress': 'En cours',
      'remediation.completed': 'Complété',
      'trust_score': 'Score de Confiance IA',
      'regulatory_threshold': 'Seuil Réglementaire',
      'users.list': 'Liste des Utilisateurs',
      'users.add': 'Ajouter un Utilisateur',
      'users.name': 'Nom',
      'users.email': 'Email',
      'users.role': 'Rôle',
      'users.department': 'Département',
      'users.manager': 'Project Manager',
      'users.data_expert': 'Expert Data',
      'users.legal_validator': 'Validateur Juridique',
      'users.auditor': 'Auditeur',
      'users.technical_lead': 'Lead Technique',
      'users.admin': 'Administrateur',
      'projects.title': 'Gestion des Projets IA',
      'projects.create': 'Créer un Projet',
      'projects.edit': 'Modifier le Projet',
      'projects.name': 'Nom du Projet',
      'projects.description': 'Description',
      'projects.phase': 'Phase Actuelle',
      'projects.members': 'Membres',
      'projects.trust_score': 'Score de Confiance',
      'projects.status': 'État',
      'projects.created': 'Créé le',
      'projects.modified': 'Modifié le',
      'project.sources': 'Sources & Documentation',
      'project.no_sources': 'Aucune source disponible',
      'project.compliance': 'Conformité & Documents',
      'project.compliance_documents': 'Documents de Conformité',
      'project.compliance_checklist': 'Checklist de Conformité',
      'project.compliance_requirements': 'Exigences de Conformité',
      'project.add_document': 'Ajouter Document',
      'project.add_requirement': 'Ajouter Exigence',
      'project.document_name': 'Nom du Document',
      'project.document_category': 'Catégorie',
      'project.document_description': 'Description',
      'project.document_file': 'Fichier PDF',
      'project.requirement_name': 'Nom de l\'Exigence',
      'project.requirement_status': 'Statut',
      'project.compliance_notes': 'Notes de Conformité',
      'project.procedures': 'Procédures',
      'project.tab_overview': '📊 Aperçu',
      'project.tab_sources': '🔗 Sources de Données',
      'project.tab_stakeholders': '🤝 Parties Prenantes',
      'project.tab_usecases': '🤖 Cas d\'Usage IA',
      'project.tab_compliance': '⚖️ Conformité',
      'audit.title': 'Audit Profond',
      'audit.type': 'Type d\'Audit',
      'audit.anonymization': 'Anonymisation',
      'audit.bias_detection': 'Détection de Biais',
      'audit.data_quality': 'Qualité des Données',
      'audit.compliance': 'Conformité',
      'audit.findings': 'Résultats',
      'audit.recommendations': 'Recommandations',
      'audit.conducted_by': 'Réalisé par',
      'audit.conducted_at': 'Date de réalisation',
      'anonymization.re_identification': 'Probabilité de Ré-identification',
      'anonymization.threshold': 'Seuil Réglementaire (5%)',
      'anonymization.compliant': 'Conforme',
      'anonymization.non_compliant': 'Non Conforme',
      'passport.title': 'Passeport de Confiance IA',
      'passport.generate': 'Générer le Passeport',
      'passport.sign': 'Signer le Passeport',
      'passport.status_draft': 'Brouillon',
      'passport.status_signed': 'Signé',
      'kb.title': 'Knowledge Base',
      'kb.subtitle': 'Guide complet sur la gouvernance des données, les méthodologies IA et les réglementations RGPD & EU AI Act',
      'kb.data_types_title': 'Types de Données',
      'kb.governance_title': 'Gouvernance des Données',
      'kb.methodologies_title': 'Méthodologies d\'Utilisation des Données',
      'kb.rgpd_title': 'Réglementation RGPD - Points Clés',
      'kb.ai_act_title': 'EU AI Act - Guide de Conformité',
      'kb.compliance_practices_title': 'Meilleures Pratiques et Conformité',
      'kb.examples': 'Exemples',
      'kb.regulations': 'Réglementations',
      'kb.best_practices': 'Meilleures Pratiques',
      'kb.key_elements': 'Éléments Clés',
      'kb.implementation': 'Implémentation',
      'kb.use_cases': 'Cas d\'Usage',
      'kb.data_requirements': 'Exigences des Données',
      'kb.compliance_points': 'Points de Conformité',
      'kb.key_points': 'Points Clés',
      'kb.do': 'À Faire',
      'kb.dont': 'À Éviter',
      'kb.risk_levels': 'Niveaux de Risque',
      'kb.requirements': 'Exigences',
      'kb.key_requirements': 'Exigences Clés',
      'kb.compliance_checklist': 'Liste de Conformité',
      'kb.actions': 'Actions',
      'kb.benefits': 'Avantages',
      'kb.common_mistakes': 'Erreurs Courantes',
      'kb.collection_privacy_title': 'Collecte de Données et Confidentialité',
      'kb.data_quality_title': 'Qualité des Données',
      'kb.data_security_title': 'Sécurité et Protection des Données',
      'kb.data_ethics_title': 'Éthique des Données',
      'lib.videos_title': 'Bibliothèque Vidéos',
      'lib.videos_subtitle': 'Ressources éducatives et meilleures pratiques pour la gouvernance de l\'IA',
      'lib.add_video': 'Ajouter Vidéo',
      'lib.add_video_desc': 'Partagez une URL vidéo de YouTube ou d\'autres plateformes',
      'lib.video_url_placeholder': 'Entrez l\'URL de la vidéo (YouTube, Vimeo, etc.)',
      'lib.add_btn': 'Ajouter Vidéo',
      'lib.search_videos': 'Rechercher des vidéos par titre ou contenu...',
      'lib.no_videos': 'Aucune vidéo trouvée. Essayez d\'ajuster vos filtres.',
      'lib.author': 'Auteur',
      'lib.published': 'Publié',
      'lib.duration': 'Durée',
      'lib.summary': 'Résumé',
      'lib.key_points': 'Points Clés',
      'lib.share': 'Partager',
      'lib.copy_link': 'Copier le Lien',
      'lib.open_original': 'Ouvrir Original',
      'lib.link_copied': 'Lien copié dans le presse-papiers !',
      'lib.user_video_desc': 'Ressource vidéo ajoutée par l\'utilisateur',
      'lib.enter_url': 'Veuillez entrer une URL vidéo valide',
      'login.subtitle': 'Connexion au système de gouvernance IA',
      'login.email': 'Adresse Email',
      'login.emailPlaceholder': 'votre@email.com',
      'login.hashid': 'Identifiant Projet',
      'login.hashidPlaceholder': 'Entrez votre ID projet',
      'login.submit': 'Se Connecter',
      'login.loggingIn': 'Connexion en cours...',
      'login.demoTitle': 'Projets de Démonstration',
      'login.project1': 'Projet 1: Système de Recommandation IA',
      'login.project2': 'Projet 2: Analyse de Données Prédictive',
      'settings.title': 'Paramètres et Configuration',
      'settings.general': 'Paramètres Généraux',
      'settings.policies': 'Politiques de Gouvernance',
      'settings.audit_config': 'Configuration Audit',
      'settings.compliance_rules': 'Règles de Conformité',
      'settings.project_policies': 'Politiques Projet',
      'footer.version': 'Version',
      'footer.legal': 'Mentions Légales',
      'footer.terms': 'Conditions Générales d\'Utilisation',
      'footer.privacy': 'Politique de Confidentialité',
      'footer.copyright': '© *** - Tous droits réservés',
    }
  },
  en: {
    translation: {
      'app.title': 'HinaPulse',
      'app.subtitle': 'AI Governance Platform',
      'menu.home': 'Home',
      'menu.users': 'Users',
      'menu.trust_passport': 'Trust Passport',
      'menu.activities': 'Activity History',
      'menu.settings': 'Settings',
      'menu.admin': 'Admin Panel',
      'menu.logout': 'Logout',
      'breadcrumb.home': 'Home',
      'breadcrumb.users': 'Users',
      'breadcrumb.passport': 'Trust Passport',
      'breadcrumb.settings': 'Settings',
      'breadcrumb.activities': 'Activity History',
      'common.search': 'Search...',
      'common.overview': 'Overview',
      'common.edit': 'Edit',
      'common.delete': 'Delete',
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.add': 'Add',
      'common.back': 'Back',
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.success': 'Success',
      'common.name': 'Name',
      'common.title': 'Title',
      'common.description': 'Description',
      'common.status': 'Status',
      'common.date': 'Date',
      'common.not_found': 'No items found',
      'common.reset': 'Reset',
      'common.all': 'All',
      'common.owner': 'Owner',
      'common.members': 'Members',
      'activity.title': 'Activity History',
      'activity.subtitle': 'Track all actions performed on AI projects',
      'activity.filter_type': 'Action Type',
      'activity.filter_status': 'Status',
      'activity.filter_days': 'Days Elapsed',
      'activity.created_project': 'Project Created',
      'activity.created_passport': 'Passport Created',
      'activity.updated_passport': 'Passport Updated',
      'activity.signed_passport': 'Passport Signed',
      'activity.created_alert': 'Alert Created',
      'activity.added_data_source': 'Data Source Added',
      'activity.success': 'Success',
      'activity.warning': 'Warning',
      'activity.no_activities': 'No activities found',
      'activity.total_activities': 'Total Activities',
      'activity.projects_created': 'Projects Created',
      'activity.passports_created': 'Passports Created',
      'activity.alerts_created': 'Alerts Created',
      'auth.profile': 'My Profile',
      'auth.settings': 'Settings',
      'auth.language': 'Language',
      'auth.french': 'French',
      'auth.english': 'English',
      'dashboard.title': 'Dashboard',
      'dashboard.projects': 'AI Projects',
      'dashboard.active_projects': 'Active Projects',
      'dashboard.alerts': 'Alerts',
      'dashboard.recent_activity': 'Recent Activity',
      'dashboard.pipeline_progress': 'Pipeline Progress',
      'dashboard.global_progress': 'Global Projects Progress',
      'dashboard.total_projects': 'Total Projects',
      'dashboard.avg_progress': 'Average Progress',
      'dashboard.avg_trust_score': 'Average Score',
      'dashboard.progress': 'Progress',
      'dashboard.statistics': 'Statistics',
      'dashboard.current_phase': 'Current Phase',
      'dashboard.checkpoints': 'Checkpoints',
      'dashboard.phases_completed': 'Completed Phases',
      'projects.team_size': 'Team Size',
      'projects.budget': 'Budget',
      'projects.risk_level': 'Risk Level',
      'projects.compliance': 'Compliance',
      'projects.data_sources': 'Data Sources',
      'projects.stakeholders': 'Stakeholders',
      'projects.checkpoints': 'Checkpoints',
      'pipeline.ideation': 'Ideation',
      'pipeline.data_collection': 'Data Collection',
      'pipeline.training': 'Training',
      'pipeline.deployment': 'Deployment',
      'phase.status_pending': 'Pending',
      'phase.status_in_progress': 'In Progress',
      'phase.status_blocked': 'Blocked',
      'phase.status_completed': 'Completed',
      'checkpoint.validation': 'Checkpoint Validation',
      'checkpoint.verified': 'Verified',
      'checkpoint.pending': 'Pending',
      'alert.level_red': 'Critical',
      'alert.level_yellow': 'Warning',
      'alert.level_green': 'Compliant',
      'alert.priority': 'Priority',
      'alert.priority_critical': 'Critical',
      'alert.priority_high': 'High',
      'alert.priority_medium': 'Medium',
      'alert.priority_low': 'Low',
      'remediation.proposed': 'Proposed',
      'remediation.in_progress': 'In Progress',
      'remediation.completed': 'Completed',
      'trust_score': 'AI Trust Score',
      'regulatory_threshold': 'Regulatory Threshold',
      'users.list': 'User List',
      'users.add': 'Add User',
      'users.name': 'Name',
      'users.email': 'Email',
      'users.role': 'Role',
      'users.department': 'Department',
      'users.manager': 'Project Manager',
      'users.data_expert': 'Data Expert',
      'users.legal_validator': 'Legal Validator',
      'users.auditor': 'Auditor',
      'users.technical_lead': 'Technical Lead',
      'users.admin': 'Administrator',
      'projects.title': 'AI Project Management',
      'projects.create': 'Create Project',
      'projects.edit': 'Edit Project',
      'projects.name': 'Project Name',
      'projects.description': 'Description',
      'projects.phase': 'Current Phase',
      'projects.members': 'Members',
      'projects.trust_score': 'Trust Score',
      'projects.status': 'Status',
      'projects.created': 'Created',
      'projects.modified': 'Modified',
      'project.sources': 'Sources & Documentation',
      'project.no_sources': 'No sources available',
      'project.compliance': 'Compliance & Documents',
      'project.compliance_documents': 'Compliance Documents',
      'project.compliance_checklist': 'Compliance Checklist',
      'project.compliance_requirements': 'Compliance Requirements',
      'project.add_document': 'Add Document',
      'project.add_requirement': 'Add Requirement',
      'project.document_name': 'Document Name',
      'project.document_category': 'Category',
      'project.document_description': 'Description',
      'project.document_file': 'PDF File',
      'project.requirement_name': 'Requirement Name',
      'project.requirement_status': 'Status',
      'project.compliance_notes': 'Compliance Notes',
      'project.procedures': 'Procedures',
      'project.tab_overview': '📊 Overview',
      'project.tab_sources': '🔗 Data Sources',
      'project.tab_stakeholders': '🤝 Stakeholders',
      'project.tab_usecases': '🤖 AI Use Cases',
      'project.tab_compliance': '⚖️ Compliance',
      'audit.title': 'Deep Audit',
      'audit.type': 'Audit Type',
      'audit.anonymization': 'Anonymization',
      'audit.bias_detection': 'Bias Detection',
      'audit.data_quality': 'Data Quality',
      'audit.compliance': 'Compliance',
      'audit.findings': 'Findings',
      'audit.recommendations': 'Recommendations',
      'audit.conducted_by': 'Conducted By',
      'audit.conducted_at': 'Conducted At',
      'anonymization.re_identification': 'Re-identification Probability',
      'anonymization.threshold': 'Regulatory Threshold (5%)',
      'anonymization.compliant': 'Compliant',
      'anonymization.non_compliant': 'Non-Compliant',
      'passport.title': 'AI Trust Passport',
      'passport.generate': 'Generate Passport',
      'passport.sign': 'Sign Passport',
      'passport.status_draft': 'Draft',
      'passport.status_signed': 'Signed',
      'kb.title': 'Knowledge Base',
      'kb.subtitle': 'Complete guide on data governance, AI methodologies and GDPR & EU AI Act regulations',
      'kb.data_types_title': 'Data Types',
      'kb.governance_title': 'Data Governance',
      'kb.methodologies_title': 'Data Usage Methodologies',
      'kb.rgpd_title': 'GDPR Regulation - Key Points',
      'kb.ai_act_title': 'EU AI Act - Compliance Guide',
      'kb.compliance_practices_title': 'Best Practices and Compliance',
      'kb.examples': 'Examples',
      'kb.regulations': 'Regulations',
      'kb.best_practices': 'Best Practices',
      'kb.key_elements': 'Key Elements',
      'kb.implementation': 'Implementation',
      'kb.use_cases': 'Use Cases',
      'kb.data_requirements': 'Data Requirements',
      'kb.compliance_points': 'Compliance Points',
      'kb.key_points': 'Key Points',
      'kb.do': 'Do',
      'kb.dont': 'Don\'t',
      'kb.risk_levels': 'Risk Levels',
      'kb.requirements': 'Requirements',
      'kb.key_requirements': 'Key Requirements',
      'kb.compliance_checklist': 'Compliance Checklist',
      'kb.actions': 'Actions',
      'kb.benefits': 'Benefits',
      'kb.common_mistakes': 'Common Mistakes',
      'kb.collection_privacy_title': 'Data Collection and Privacy',
      'kb.data_quality_title': 'Data Quality',
      'kb.data_security_title': 'Data Security and Protection',
      'kb.data_ethics_title': 'Data Ethics',
      'lib.videos_title': 'Video Library',
      'lib.videos_subtitle': 'Educational resources and best practices for AI governance',
      'lib.add_video': 'Add Video',
      'lib.add_video_desc': 'Share a video URL from YouTube or other platforms',
      'lib.video_url_placeholder': 'Enter video URL (YouTube, Vimeo, etc.)',
      'lib.add_btn': 'Add Video',
      'lib.search_videos': 'Search videos by title or content...',
      'lib.no_videos': 'No videos found. Try adjusting your filters.',
      'lib.author': 'Author',
      'lib.published': 'Published',
      'lib.duration': 'Duration',
      'lib.summary': 'Summary',
      'lib.key_points': 'Key Points',
      'lib.share': 'Share',
      'lib.copy_link': 'Copy Link',
      'lib.open_original': 'Open Original',
      'lib.link_copied': 'Link copied to clipboard!',
      'lib.user_video_desc': 'User-added video resource',
      'lib.enter_url': 'Please enter a valid video URL',
      'login.subtitle': 'AI Governance System Login',
      'login.email': 'Email Address',
      'login.emailPlaceholder': 'your@email.com',
      'login.hashid': 'Project ID',
      'login.hashidPlaceholder': 'Enter your project ID',
      'login.submit': 'Sign In',
      'login.loggingIn': 'Signing in...',
      'login.demoTitle': 'Demo Projects',
      'login.project1': 'Project 1: AI Recommendation System',
      'login.project2': 'Project 2: Predictive Data Analytics',
      'settings.title': 'Settings and Configuration',
      'settings.general': 'General Settings',
      'settings.policies': 'Governance Policies',
      'settings.audit_config': 'Audit Configuration',
      'settings.compliance_rules': 'Compliance Rules',
      'settings.project_policies': 'Project Policies',
      'footer.version': 'Version',
      'footer.legal': 'Legal Notice',
      'footer.terms': 'Terms of Service',
      'footer.privacy': 'Privacy Policy',
      'footer.copyright': '© *** - All rights reserved',
    }
  }
}

export default translations
